import type { Metadata } from "next";
import "./globals.css";

export const metadata: Metadata = {
  title: "Lobby Tracker Argentina",
  description: "Rastreando la influencia del lobby israelí en la política argentina. Seguí el dinero.",
  openGraph: {
    title: "Lobby Tracker Argentina",
    description: "Rastreando la influencia del lobby israelí en la política argentina",
    type: "website",
  },
};

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="es">
      <body className="bg-black text-white antialiased">{children}</body>
    </html>
  );
}
